// Arabic translations for Customer Management component
const arCustomerManagement = {
    customers: {
      title: 'إدارة العملاء',
      subtitle: 'البحث عن العملاء وإضافتهم وإدارتهم',
      points: 'نقاط',
      eligible: 'مؤهل',
      promo: 'عرض',
      redemption: 'استرداد',
      rate: 'النسبة',
      
      settingsInfo: {
        currentRate: 'المعدل الحالي',
        tieredRates: '',
        pointsPerCurrency: 'نقطة لكل شيكل',
        minRedemption: 'الحد الأدنى للاسترداد',
        expiration: 'صلاحية النقاط',
        months: 'شهر'
      },
      
      search: {
        placeholder: 'أدخل رقم هاتف العميل',
        button: 'بحث',
        searching: 'جاري البحث...',
        clear: 'مسح'
      },
      
      newCustomer: {
        title: 'تسجيل عميل جديد',
        nameLabel: 'اسم العميل',
        cityLabel: 'المدينة',
        employeeLabel: 'الموظف',
        selectEmployee: 'اختر الموظف',
        dateOfBirthLabel: 'تاريخ الميلاد',
        amountLabel: 'مبلغ الشراء الأولي (بالشيكل)',
        estimatedPoints: 'النقاط المتوقعة',
        includesBonus: 'يشمل مكافأة ×{{multiplier}}',
        button: 'تسجيل العميل',
        processing: 'جاري التسجيل...'
      },
      
      customerDetails: {
        points: 'نقاط',
        eligible: 'مؤهل للاسترداد!',
        redeemButton: 'استرداد النقاط',
        needsMore: 'يحتاج {{points}} نقطة أخرى للاسترداد',
        
        newPurchase: {
          title: 'تسجيل عملية شراء جديدة',
          placeholder: 'مبلغ الشراء بالشيكل',
          button: 'إضافة عملية شراء',
          processing: 'جاري الإضافة...',
          employeeLabel: 'الموظف',
        selectEmployee: 'اختر الموظف'
        },
        
        transactions: {
          title: 'سجل المعاملات',
          date: 'التاريخ',
          amount: 'المبلغ',
          points: 'النقاط',
          status: 'الحالة',
          empty: 'لا يوجد سجل معاملات متاح',
          notes: 'ملاحظات'
        }
      },
      
      directory: {
        title: 'دليل العملاء',
        tabs: {
          all: 'جميع العملاء',
          eligible: 'مؤهلين للاسترداد',
          top: 'أفضل 5 عملاء'
        },
        summary: {
          total: 'إجمالي العملاء',
          eligible: 'مؤهلين للمكافآت',
          top: 'أفضل العملاء'
        },
        empty: 'لم يتم العثور على عملاء',
        refresh: 'تحديث'
      },
      
      promotion: {
        multiplier: '{{multiplier}}× نقاط على جميع المشتريات!',
        validUntil: 'ساري حتى'
      }
    },
    
    redemption: {
      title: 'استرداد النقاط',
      availablePoints: 'نقاط متاحة',
      points: 'نقاط',
      enterPoints: 'أدخل عدد النقاط للاسترداد',
      pointsPlaceholder: 'أدخل عدد النقاط...',
      enterValidPoints: 'الرجاء إدخال عدد نقاط صحيح',
      insufficientPoints: 'النقاط المطلوبة أكثر من رصيد العميل',
      minimumPoints: 'الحد الأدنى للاسترداد هو {{minimum}} نقطة',
      manualRedemption: 'استرداد يدوي',
      note: 'استرداد النقاط سيخصمها من رصيد العميل.',
      continue: 'متابعة',
      cancel: 'إلغاء',
      close: 'إغلاق',

      confirm: {
        title: 'تأكيد الاسترداد',
        customer: 'العميل',
        currentPoints: 'النقاط الحالية',
        pointsToRedeem: 'النقاط المراد استردادها',
        remainingBalance: 'الرصيد المتبقي',
        message: 'هل أنت متأكد من استرداد {{points}} نقطة؟',
        button: 'تأكيد الاسترداد',
        processing: 'جاري المعالجة...',
        back: 'رجوع'
      },

      success: {
        title: 'تم استرداد النقاط!',
        pointsMessage: 'تم استرداد {{points}} نقطة بنجاح.'
      },

      error: {
        general: 'فشل في استرداد النقاط. الرجاء المحاولة مرة أخرى.',
        specific: 'خطأ في استرداد النقاط: {{message}}'
      }
    },
    
    notifications: {
      success: {
        customerFound: 'تم العثور على العميل {{name}}!',
        customerRegistered: 'تم تسجيل العميل {{name}}! حصل على {{points}} نقطة.',
        transactionRecorded: 'تم تسجيل المعاملة! حصل العميل على {{points}} نقطة.',
        pointsRedeemed: 'تم استرداد النقاط بنجاح! الرصيد الجديد: {{balance}} نقطة'
      },
      error: {
        customerSearch: 'خطأ في البحث عن العميل: {{message}}',
        registration: 'خطأ في تسجيل العميل: {{message}}',
        addPurchase: 'خطأ في إضافة عملية شراء: {{message}}',
        noCustomerSelected: 'لم يتم اختيار عميل',
        notEnoughPoints: 'لا يملك العميل نقاط كافية للاسترداد. الحد الأدنى المطلوب: {{minimum}} نقطة',
        loadSettings: 'فشل في تحميل الإعدادات. تم استخدام القيم الافتراضية.',
        loadRewards: 'فشل في تحميل المكافآت. قد لا تعمل وظيفة الاسترداد بشكل صحيح.',
        loadCustomers: 'فشل في تحميل العملاء: {{message}}'
      },
      validation: {
        phoneRequired: 'الرجاء إدخال رقم هاتف',
        allFieldsRequired: 'جميع الحقول مطلوبة',
        amountRequired: 'الرجاء إدخال مبلغ الشراء',
        invalidAmount: 'الرجاء إدخال مبلغ شراء صالح',
        employeeRequired: 'الرجاء اختيار الموظف'
      }
    },
    
    pagination: {
      previous: 'السابق',
      next: 'التالي'
    },

    common: {
      loading: 'جاري التحميل...',
      recent: 'حديثاً'
    }
  };
  
  export default arCustomerManagement;